<template>
  <div class="download-app-button">
    <BasePopover
      trigger="hover"
      placement="bottom-end"
      popover-class="download-app-button__popover"
      popoverType="tooltip"
      size="md"
    >
      <template #trigger>
        <BaseButton type="shade" size="sm" class="download-app-button__btn">
          <BaseSvgIcon name="emcd" class="download-app-button__icon" />
          {{ t("DownloadAppButton | ButtonText") }}
        </BaseButton>
      </template>
      <template #content>
        <div class="download-app-button__dropdown">
          <div class="download-app-button__qr-block">
            <IconQr class="download-app-button__qr" />
          </div>
          <div class="download-app-button__text">
            {{ t("DownloadAppButton | ScanQRCode") }}
          </div>
          <div class="download-app-button__links">
            <a
              :href="appStoreLink"
              target="_blank"
              class="download-app-button__store-link"
              @click.prevent="handleAppStoreClick"
            >
              <IconAppleStore class="download-app-button__store-icon" />
            </a>
            <a
              :href="googlePlayLink"
              target="_blank"
              class="download-app-button__store-link"
              @click.prevent="handleGooglePlayClick"
            >
              <IconGooglePlay class="download-app-button__store-icon" />
            </a>
          </div>
        </div>
      </template>
    </BasePopover>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { BaseButton } from "@/shared/ui";
import { BaseSvgIcon } from "@/shared/ui/BaseSvgIcon";
import { BasePopover } from "@/shared/ui";
import IconQr from "./assets/IconQr.vue";
import IconAppleStore from "./assets/IconAppleStore.vue";
import IconGooglePlay from "./assets/IconGooglePlay.vue";

const { locale, t } = useI18n();
const appStoreLink = computed(() => {
  return locale.value === "ru"
    ? "https://apps.apple.com/ru/app/emcd-mining-btc-p2p-wallet/id1606903304"
    : "https://apps.apple.com/ru/app/emcd-crypto-wallet-mining-btc/id1606903304?l=en-GB";
});

const googlePlayLink = computed(() => {
  return "https://play.google.com/store/apps/details?id=io.emcd.emcd_flutter.prod";
});

const handleAppStoreClick = () => {
  window.open(appStoreLink.value, "_blank");
  window.emcd.AnalyticsService.track("click", {
    event_type: "click",
    product: "explorer",
    screen: window.location.href.includes("transaction")
      ? "transaction"
      : "address",
    button_name: "download_app_store",
  });
};

const handleGooglePlayClick = () => {
  window.open(googlePlayLink.value, "_blank");
  window.emcd.AnalyticsService.track("click", {
    event_type: "click",
    product: "explorer",
    screen: window.location.href.includes("transaction")
      ? "transaction"
      : "address",
    button_name: "download_google_play",
  });
};
</script>

<style scoped lang="scss">
:deep(.tooltip) {
  padding: 20px !important;
  max-width: 244px !important;
}
.download-app-button {
  &__btn {
    display: flex;
    align-items: center;
    font-weight: 500;
    height: 36px;
    align-items: flex-end;
    padding: 10px 18px 10px 10px;
    gap: 8px;
    border-radius: 10px;
    line-height: 13px;
  }
  &__icon {
    width: 16px;
    height: 16px;
  }
  &__popover {
    padding: 0;
    background: none;
    box-shadow: none;
  }
  &__dropdown {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &__qr-block {
    margin-bottom: 14px;
  }
  &__qr {
    width: 202px;
    height: 202px;
  }
  &__text {
    font-size: 14px;
    text-align: center;
    margin-bottom: 39px;
    color: var(--text-secondary);
    font-weight: 400;
    max-width: 176px;
  }
  &__links {
    display: grid;
    gap: 6px;
    width: 100%;
    justify-content: center;
    grid-template-columns: repeat(2, 1fr);
  }
  &__store-link {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 14px;
    height: 36px;
    border-radius: 8px;
    background: #232323;
    color: #fff;
    font-weight: 500;
    text-decoration: none;
    font-size: 14px;
    transition: background 0.2s;
    border: 1px solid #2d2d2d;

    &:hover {
      background: #fff;
      color: #0a0a0a;
    }
  }
  &__store-icon {
    width: 20px;
    height: 20px;
  }
}
</style>
